<div class="reporting-stations-dashboard">
  <sc-flex vertical stretchContent fitHeight>

    <sc-padding>
      <sc-flex>
        <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
        <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
        <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
        <sc-content-spacer></sc-content-spacer>
        <sc-button dictionaryKey="tmc-yard.ui.reporting.station-occupancy.action.print-hourly" class="item margin-left-25" (click)="printHourlyReport()"></sc-button>
      </sc-flex>
    </sc-padding>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex-fitting-content vertical>
      <ng-container *ngIf="data != null && this.data.chartSvg">
        <sc-padding fitHeight>
          <div class="svg-chart" [innerHtml]="this.data.chartSvg | trustHtml"></div>
        </sc-padding>
      </ng-container>
    </sc-flex-fitting-content>

  </sc-flex>

</div>
